import React, { useEffect } from "react";
import { Link } from "gatsby";
import { connect } from "react-redux";

function StoryCard(props) {
  const { story, auth } = props;

  useEffect(() => {}, [auth.isAuthenticated]);
  return (
    <Link
      className="m-4 p-4 h-48 w-56 text-center flex flex-col items-center justify-center bg-primary border rounded-lg shadow-lg hover-up relative"
      to={`/stories${story.fields.slug}`}
    >
      <h2 className="font-bold text-3xl leading-tight">{story.title}</h2>
      <p className="mt-1 leading-none">{story.author}</p>

      {story.isPremiumStory ? (
        !props.auth.purchases.includes(story.title) ? (
          <div className="absolute uppercase tracking-wider text-xs text-indigo-100 top-0 right-0 m-2 p-1 px-2 rounded bg-indigo-500 font-sans">
            Premium
          </div>
        ) : (
          <div className="absolute uppercase tracking-wider text-xs text-indigo-100 top-0 right-0 m-2 p-1 px-2 rounded bg-green-500 font-sans">
            Purchased
          </div>
        )
      ) : null}
    </Link>
  );
}

const mapStateToProps = (state) => ({ auth: state.auth });

export default connect(mapStateToProps, {})(StoryCard);
